import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./PrivacyPages.css"; // Reuse the same CSS file

const Privacy_Policy = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/privacy.md") // Ensure this file exists
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="legal-container">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default Privacy_Policy;
